<div class="container">
  <input *ngFor="let number of numbers; let idx = index; trackBy: trackByIndex"
         class="number"
         pplInput
         type="text"
         autocomplete="off"
         [attr.minlength]="1"
         [attr.maxlength]="1"
         [value]="number"
         (input)="onInput($event, idx)"
         (paste)="onPaste($event)"
         (keyup)="onKeyUp($event)" />
</div>